import { StyleSheet } from 'react-native'
import HelperPlatform from 'utils/helper-platform'
import _ from "lodash";

const HelperStyles  = {
	
	toObject: ( styles ) => {
		const isWeb = HelperPlatform.isWeb();
		
		let object = {};
		
		if ( !_.isArray( styles ) ) {
			styles = [ styles ]
		}
		
		_.forEach( styles, ( style ) => {
			
			if ( _.isArray( style ) ) {
				style = HelperStyles.toObject( style )
			}
			
			object = {
				...object, ...( isWeb ? StyleSheet.flatten( style ) : style )
			};
		} );
		
		return object;
	},
	
	isColorDark: ( color ) => {
		
		// convert color to rgb if hex color
		if ( color.indexOf( '#' ) === 0 ) {
			color = HelperStyles.hexToRgb( color )
		}
		
		const rgb = color.match( /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/ );
		const r = rgb[ 1 ];
		const g = rgb[ 2 ];
		const b = rgb[ 3 ];
		const brightness = ( ( r * 299 ) + ( g * 587 ) + ( b * 114 ) ) / 1000;
		return brightness < 130;
	},
	
	hexToRgb: ( color ) => {
		color = color.replace( '#', '' );
		
		const bigint = parseInt( color, 16 );
		const r = ( bigint >> 16 ) & 255;
		const g = ( bigint >> 8 ) & 255;
		const b = bigint & 255;
		
		return `rgb(${r}, ${g}, ${b})`;
	},
	
	generateHexColor: () => {
		const randomColor = Math.floor(Math.random()*16777215).toString(16);
		return `#${randomColor}`;
	}
}

export default HelperStyles
